import beTwMerge from '@/utils/beTwMerge';
import { IDataShowroom, ShowroomStatusOptions } from '@/components/BuilderIO/common/CommonFields';
import { GetHeadingLevel } from '@/components/BuilderIO/common/StoreLocator/utils';
import StoreLocatorCardActive from './StoreLocatorCardActive';

export interface IStoreLocatorCard {
  handleBookAppointmentClick: () => void;
  selectShowroom: (event: any) => void;
  showroom?: IDataShowroom;
  isSelected?: boolean;
  titleHTMLTag: string;
  isMobile: boolean;
  index: number;
}

export default function StoreLocatorCard({
  handleBookAppointmentClick,
  selectShowroom,
  showroom,
  isSelected,
  titleHTMLTag = 'h1',
  isMobile,
  index,
}: IStoreLocatorCard) {
  if (isSelected && isMobile) {
    return (
      <StoreLocatorCardActive
        index={index}
        showroomSelected={showroom}
        bookAppointment={handleBookAppointmentClick}
        hasBeenSelected={isSelected}
      />
    );
  }

  const handleClick = (e: any) => {
    selectShowroom(e);
  };

  const isComingSoon = showroom?.status === ShowroomStatusOptions.ComingSoon;

  function getAddress() {
    if (isComingSoon) {
      return 'Coming Soon';
    }
    return `${showroom?.addressLine1 || ''} ${showroom?.addressLine2 ? `${showroom?.addressLine2}, ` : ''} ${showroom?.city ? `${showroom?.city}, ` : ''} ${showroom?.state} ${showroom?.zipCode}`;
  }

  function getCta() {
    if (isComingSoon) {
      return (
        <a
          href={showroom?.storePageLink}
          className="tw-cursor-pointer tw-underline tw-font-normal tw-leading-normal tw-text-left tw-text-[14px]"
          tabIndex={-1}
        >
          Sign Up for Updates
        </a>
      );
    }
    return (
      <a
        className="tw-cursor-pointer tw-underline tw-font-normal tw-leading-normal tw-text-left tw-text-[14px]"
        onClick={handleBookAppointmentClick}
        role="button"
        tabIndex={-1}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            handleBookAppointmentClick();
          }
        }}
      >
        {showroom?.status === ShowroomStatusOptions.PreBook ? 'Pre-Book Appointment' : 'Book Appointment'}
      </a>
    );
  }

  return (
    <div
      className={beTwMerge(
        'tw-flex tw-flex-col tw-p-[12px] tw-border tw-border-solid tw-border-[#D9D9D9] lg:tw-max-w-[309px] hover:tw-cursor-pointer',
        isSelected ? 'tw-border-[1.5px] tw-border-[#0D6363]' : ''
      )}
      onClick={handleClick}
      tabIndex={0}
      id={`tab-${index}`}
      role="tab"
      aria-selected={isSelected}
      aria-controls={`panel-${index}`}
      onKeyDown={event => {
        if (event.key === 'Enter') {
          handleClick(event);
        }
      }}
    >
      <div className={beTwMerge('lg:tw-max-w-[285px])}', isSelected && isMobile ? 'tw-hidden' : '')}>
        <GetHeadingLevel
          mainLevel={titleHTMLTag}
          asClass
          currentLevel={2}
          styles="tw-font-base !tw-mb-0 tw-text-left !tw-text-[1rem] tw-not-italic tw-font-normal tw-capitalize tw-leading-normal tw-w-[285px] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap"
        >
          {isMobile
            ? `${showroom?.displayName1}${showroom?.displayName2 ? ` - ${showroom?.displayName2}` : ''}`
            : formatTitle(showroom?.displayName1, showroom?.displayName2)}
        </GetHeadingLevel>
        <p className="!tw-font-book tw-font-[350] tw-w-[285px] tw-mb-[12px] tw-text-[14px] tw-text-[#4D4D4D] tw-not-italic tw-capitalize tw-leading-normal tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
          {showroom?.setsterLocationId === 'Virtual Appointment' ? 'Video Consultation' : getAddress()}
        </p>
        {getCta()}
      </div>

      <div className={beTwMerge(isSelected && isMobile ? 'tw-block' : 'tw-hidden')}>
        <StoreLocatorCardActive
          index={index}
          showroomSelected={showroom}
          bookAppointment={handleBookAppointmentClick}
          hasBeenSelected={!!isSelected}
        />
      </div>
    </div>
  );
}

const formatTitle = (displayName1, displayName2) => {
  let formattedTitle = `${displayName1}${displayName2 ? ` - ${displayName2}` : ''}`;

  if (formattedTitle.length > 37) {
    formattedTitle = `${formattedTitle.substring(0, 37)}...`;
  }
  return formattedTitle;
};
